import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import {
  featuresSetupUpdateFeature,
  featuresSetupUpdateFeatures,
  setFeaturesSetupTogglePopupOpened
} from "../featuresActions";
import FeaturesSetupTogglePopupTable from "./FeaturesSetupTogglePopupTable";
import {
  getCurrentFeatureToolSettings,
  getFilteredFeatures,
} from "../featuresFunctions";
import {AVAILABLE_VISUALIZERS} from "../../../constants/dashboard";

const FeaturesSetupTogglePopup = (props) => {

  const {setFeaturesSetupTogglePopupOpened, featuresSetupTogglePopupOpened, featuresSetupTogglePopupFeature, groupName,
    featuresSetupUpdateFeature, featuresSetupUpdateFeatures, selectedFeatures} = props;

  const [popupFeature, setPopupFeature] = useState({});
  const [defaultPopupFeature, setDefaultPopupFeature] = useState({});

  useEffect(() => {
    if (featuresSetupTogglePopupFeature) {
      const toolSettings = getCurrentFeatureToolSettings(featuresSetupTogglePopupFeature);
      setPopupFeature({...featuresSetupTogglePopupFeature, toolSettings});
      setDefaultPopupFeature({...featuresSetupTogglePopupFeature, toolSettings});
    } else {
      let feature = {
        toolSettings: Object.keys(AVAILABLE_VISUALIZERS).map(visualizer => {
          return {
            tool: visualizer,
            enableVisualizer: selectedFeatures.every(dbFeature => {
              const toolSettings = dbFeature.unlinkedData ? dbFeature.unlinkedData.toolSettings : dbFeature.toolSettings;
              if (dbFeature.unlinkedData && !toolSettings.length) {
                switch (visualizer) {
                  case AVAILABLE_VISUALIZERS.bathroom:
                    return !dbFeature.unlinkedData.hideFromBV
                  case AVAILABLE_VISUALIZERS.kitchen:
                    return !dbFeature.unlinkedData.hideFromKV
                  default:
                    return false
                }
              }
              const currentSetting = toolSettings.find(setting => setting.tool === visualizer);
              return currentSetting && currentSetting.enableVisualizer
            }),
            enableQuotingTool: selectedFeatures.every(dbFeature => {
              const toolSettings = dbFeature.unlinkedData ? dbFeature.unlinkedData.toolSettings : dbFeature.toolSettings;
              if (dbFeature.unlinkedData && !toolSettings.length) {
                switch (visualizer) {
                  case AVAILABLE_VISUALIZERS.bathroom:
                    return !dbFeature.unlinkedData.hideFromBVQT
                  case AVAILABLE_VISUALIZERS.kitchen:
                    return !dbFeature.unlinkedData.hideFromKVQT
                  default:
                    return false
                }
              }
              const currentSetting = toolSettings.find(setting => setting.tool === visualizer);
              return currentSetting && currentSetting.enableQuotingTool
            }),
          }
        })
      };
      setPopupFeature(feature);
      setDefaultPopupFeature({...feature});
    }
  }, [])

  if (!featuresSetupTogglePopupOpened) {
    return null
  }

  const closePopup = () => {
    setFeaturesSetupTogglePopupOpened(false);
  };

  const saveClick = () => {
    if (popupFeature.toolSettings.some(tool => {
      return tool.enableQuotingTool !== defaultPopupFeature.toolSettings.enableQuotingTool
        || tool.enableVisualizer !== defaultPopupFeature.toolSettings.enableVisualizer
    })) {
      if (featuresSetupTogglePopupFeature) {
        featuresSetupUpdateFeature(featuresSetupTogglePopupFeature, "toolSettings",  popupFeature.toolSettings);
      } else {
        featuresSetupUpdateFeatures("toolSettings", popupFeature.toolSettings)
      }
    }
    closePopup()
  }

  return (
    <div className={"ui-popup ui-popup--wizard ui-popup--wizard--5"}>
      <button className="ui-popup-header__close" onClick={closePopup}/>
      <div className="ui-popup__header">
          <span className="ui-popup__header-title">
            <FormattedMessage id="features.setup.togglePopup.title"/>
            <span> {featuresSetupTogglePopupFeature ? featuresSetupTogglePopupFeature.name : groupName} </span>
            {featuresSetupTogglePopupFeature ? null : <FormattedMessage id="features.setup.togglePopup.features"/>}
          </span>
      </div>
      <div className="ui-popup-body ui-popup-body--small">
        <FeaturesSetupTogglePopupTable setPopupFeature={setPopupFeature} popupFeature={popupFeature}/>
      </div>
      <div className="ui-popup-footer">
        <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--blue" onClick={closePopup}>
          <FormattedMessage id="messageBox.buttons.cancel"/>
        </button>
        <button className="ui-button5 ui-button5--wide text-uppercase ui-button5--green" onClick={saveClick}>
          <FormattedMessage id="messageBox.buttons.update"/>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {featuresSetupTogglePopupOpened, featuresSetupTogglePopupFeature, groupName} = store.featuresSetupState;
  const featuresList = getFilteredFeatures(store, false, true);
  const selectedFeaturesOnly = getFilteredFeatures(store, true, true);
  const selectedFeatures = selectedFeaturesOnly.length ? selectedFeaturesOnly : featuresList;

  return {
    featuresSetupTogglePopupOpened,
    featuresSetupTogglePopupFeature,
    groupName,
    selectedFeatures,
  };
};

const mapDispatchToProps = {
  setFeaturesSetupTogglePopupOpened,
  featuresSetupUpdateFeature,
  featuresSetupUpdateFeatures,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupTogglePopup)
)
